import { useNavigate } from 'react-router'
import styled from 'styled-components'

const StyledLogo = styled.div`
  padding: 4px 12px;
  cursor: pointer;
  background-color: var(--color-system-gray-7);
  border-radius: 20px;
  img {
    width: 60px;
  }
`
interface IProps {
  src?: string
}

const Logo = (props: IProps) => {
  const { src = '/images/logo.svg' } = props
  const navigation = useNavigate()

  return (
    <StyledLogo onClick={() => navigation('/')}>
      <img src={src} alt="logo" className="img-logo" />
    </StyledLogo>
  )
}

export default Logo
